<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 181 142"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>alcoholic-beverage-consumers</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-605.000000, -452.000000)">
        <g
          id="alcoholic-beverage-consumers"
          transform="translate(606.000000, 452.000000)">
          <g id="Background">
            <g id="New_Symbol_78-22">
              <path
                id="Path"
                d="M171.81819,81.8636364 C171.833488,48.4388367 151.515793,18.3656261 120.500271,5.90549507 C89.4847491,-6.55463598 54.0086879,1.10407148 30.8957486,25.2496612 C7.78280942,49.395251 1.68105362,85.1719934 15.4840909,115.613636 L164.495455,115.613636 C169.317126,105.015193 171.813985,93.5073257 171.81819,81.8636364 Z"
                class="fill-extra-light"
                fill-rule="nonzero" />
              <line
                id="Path"
                x1="10.1863636"
                y1="115.634091"
                x2="169.731818"
                y2="115.634091"
                class="stroke"
                stroke-width="2.04545455"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="0.981818182"
                y1="115.634091"
                x2="6.09545455"
                y2="115.634091"
                class="stroke"
                stroke-width="2.04545455"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="173.822727"
                y1="115.634091"
                x2="178.936364"
                y2="115.634091"
                class="stroke"
                stroke-width="2.04545455"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
          </g>
          <g
            id="Scene"
            transform="translate(29.636364, 6.181818)">
            <path
              id="Path"
              d="M114.527273,94.0909091 C114.520375,85.4186308 110.963609,77.1272119 104.684417,71.1455566 C98.4052243,65.1639013 89.951041,62.0135054 81.2886364,62.4272727 C64.183786,63.555395 50.9398893,77.8498246 51.1181818,94.9909091 L51.1181818,97.1795455 C51.1181818,98.3092188 52.033963,99.225 53.1636364,99.225 L63.3909091,99.225 L63.3909091,109.452273 L102.254545,109.452273 L102.254545,99.225 L112.481818,99.225 C113.611492,99.225 114.527273,98.3092188 114.527273,97.1795455 L114.527273,94.0909091 Z"
              class="fill-light"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M114.527273,94.0909091 C114.520375,85.4186308 110.963609,77.1272119 104.684417,71.1455566 C98.4052243,65.1639013 89.951041,62.0135054 81.2886364,62.4272727 C64.183786,63.555395 50.9398893,77.8498246 51.1181818,94.9909091 L51.1181818,97.1795455 C51.1181818,98.3092188 52.033963,99.225 53.1636364,99.225 L63.3909091,99.225 L63.3909091,109.452273 L102.254545,109.452273 L102.254545,99.225 L112.481818,99.225 C113.611492,99.225 114.527273,98.3092188 114.527273,97.1795455 L114.527273,94.0909091 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="63.3909091"
              y1="91.0431818"
              x2="63.3909091"
              y2="99.225"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="102.254545"
              y1="91.0431818"
              x2="102.254545"
              y2="99.5522727"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M75.6636364,63.4090909 C75.6636364,67.3629476 78.8688705,70.5681818 82.8227273,70.5681818 C86.776584,70.5681818 89.9818182,67.3629476 89.9818182,63.4090909 L89.9818182,56.25 L75.6636364,56.25 L75.6636364,63.4090909 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M82.8636364,70.5886364 C78.9097796,70.5886364 75.7045455,67.3834022 75.7045455,63.4295455 L75.7045455,56.2704545 L90.0227565,56.2704545 L90.0227565,63.4090909 C90.0281623,65.3113414 89.2763031,67.1375434 87.9331236,68.4845606 C86.5899441,69.8315778 84.7658946,70.5886364 82.8636364,70.5886364 L82.8636364,70.5886364 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="102.254545"
              y="99.225"
              width="10.2272727"
              height="10.2272727" />
            <path
              id="Path"
              d="M28.6181402,120.681818 C28.6181402,117.857635 30.9076348,115.568182 33.7318182,115.568182 L37.8227273,115.568182 C46.2859489,115.545703 53.1411576,108.690494 53.1636364,100.227273 L53.1636364,99.2045455 L63.3909091,99.2045455 L63.3909091,100.227273 C63.3797162,114.330909 51.9672054,125.770854 37.8636364,125.816073 L33.7727273,125.816073 C32.4058796,125.826855 31.0915433,125.29012 30.1230854,124.325505 C29.1546275,123.36089 28.6126704,122.048699 28.6181402,120.681818 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M103.318182,34.7727273 L103.318182,29.6590909 C103.318182,18.3623574 94.1603699,9.20454545 82.8636364,9.20454545 C71.5669028,9.20454545 62.4090909,18.3623574 62.4090909,29.6590909 L62.4090909,34.7727273 C60.1497442,34.7727273 58.3181818,36.6042897 58.3181818,38.8636364 C58.3181818,41.1229831 60.1497442,42.9545455 62.4090909,42.9545455 L62.6545455,42.9545455 C64.2109731,52.9105956 72.7866625,60.2498071 82.8636364,60.2498071 C92.9406102,60.2498071 101.5163,52.9105956 103.072727,42.9545455 L103.318182,42.9545455 C105.577529,42.9545455 107.409091,41.1229831 107.409091,38.8636364 C107.409091,36.6042897 105.577529,34.7727273 103.318182,34.7727273 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="71.0613636"
              cy="43.4863636"
              r="2.55681818" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="94.5840909"
              cy="43.4863636"
              r="2.55681818" />
            <path
              id="Path"
              d="M76.7272727,48.6818182 C80.1759063,51.9237254 85.5513664,51.9237254 89,48.6818182"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M103.318182,34.7727273 L103.318182,29.6590909 C103.318182,18.3623574 94.1603699,9.20454545 82.8636364,9.20454545 C71.5669028,9.20454545 62.4090909,18.3623574 62.4090909,29.6590909 L62.4090909,34.7727273 C60.1497442,34.7727273 58.3181818,36.6042897 58.3181818,38.8636364 C58.3181818,41.1229831 60.1497442,42.9545455 62.4090909,42.9545455 L62.6545455,42.9545455 C64.2109731,52.9105956 72.7866625,60.2498071 82.8636364,60.2498071 C92.9406102,60.2498071 101.5163,52.9105956 103.072727,42.9545455 L103.318182,42.9545455 C105.577529,42.9545455 107.409091,41.1229831 107.409091,38.8636364 C107.409091,36.6042897 105.577529,34.7727273 103.318182,34.7727273 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M94.0727273,36.8181818 C93.549454,35.5876979 92.3416713,34.7888601 91.0045455,34.7888601 C89.6674196,34.7888601 88.4596369,35.5876979 87.9363636,36.8181818"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M77.6886364,36.8181818 C77.1653631,35.5876979 75.9575804,34.7888601 74.6204545,34.7888601 C73.2833287,34.7888601 72.075546,35.5876979 71.5522727,36.8181818"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M93.2954545,22.5 C82.0454545,33.75 66.7045455,32.7272727 66.7045455,58.2954545 C64.0870335,54.8870362 62.0167341,51.0914873 60.5681818,47.0454545 C59.4287042,52.8338324 59.7806525,58.8169541 61.5909091,64.4318182 C52.3863636,60.3409091 43.1818182,15.3409091 77.9545455,7.15909091 C77.9545455,4.09090909 72.8409091,2.04545455 72.8409091,2.04545455 C72.8409091,2.04545455 83.0681818,0 88.1818182,7.15909091 C90.2272727,4.09090909 87.1590909,0 87.1590909,0 C87.1590909,0 96.3636364,3.06818182 96.3636364,10.2272727 C104.545455,4.09090909 110.681818,12.2727273 110.681818,12.2727273 C105.568182,11.25 103.522727,13.2954545 103.522727,13.2954545 C108.636364,17.3863636 108.472727,28.4931818 108.636364,35.7954545 C108.672844,44.3754356 104.460429,52.4173178 97.3863636,57.2727273 C97.3863636,57.2727273 101.477273,31.6636364 93.2954545,22.5 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M93.2954545,22.5 C82.0454545,33.75 66.7045455,32.7272727 66.7045455,58.2954545 C64.0870335,54.8870362 62.0167341,51.0914873 60.5681818,47.0454545 C59.4287042,52.8338324 59.7806525,58.8169541 61.5909091,64.4318182 C52.3863636,60.3409091 43.1818182,15.3409091 77.9545455,7.15909091 C77.9545455,4.09090909 72.8409091,2.04545455 72.8409091,2.04545455 C72.8409091,2.04545455 83.0681818,0 88.1818182,7.15909091 C90.2272727,4.09090909 87.1590909,0 87.1590909,0 C87.1590909,0 96.3636364,3.06818182 96.3636364,10.2272727 C104.545455,4.09090909 110.681818,12.2727273 110.681818,12.2727273 C105.568182,11.25 103.522727,13.2954545 103.522727,13.2954545 C108.636364,17.3863636 108.472727,28.4931818 108.636364,35.7954545 C108.672844,44.3754356 104.460429,52.4173178 97.3863636,57.2727273 C97.3863636,57.2727273 101.477273,31.6636364 93.2954545,22.5 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="63.3909091"
              y="95.1340909"
              width="38.8636364"
              height="5.11363636" />
            <rect
              id="Rectangle"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="63.3909091"
              y="104.338636"
              width="38.8636364"
              height="5.11363636" />
            <ellipse
              id="Oval"
              class="fill-extra-light"
              fill-rule="nonzero"
              cx="27.5954545"
              cy="131.952273"
              rx="14.3181818"
              ry="3.06818182" />
            <path
              id="Path"
              d="M35.6136364,84.1295455 L35.6136364,84.1295455 C35.1111367,83.9215309 34.7121651,83.5219639 34.5049002,83.0191546 C34.2976353,82.5163453 34.2991433,81.951695 34.5090909,81.45 L42.1590909,62.7340909 C42.5923195,61.6987453 43.7788943,61.2058604 44.8181818,61.6295455 L44.8181818,61.6295455 C45.861524,62.0548015 46.3645224,63.2437068 45.9431818,64.2886364 L38.2931818,83.0045455 C38.0890929,83.5107361 37.6911693,83.9143701 37.1879379,84.1256505 C36.6847065,84.3369308 36.1179071,84.3383332 35.6136364,84.1295455 L35.6136364,84.1295455 Z"
              class="stroke fill-white"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M34.1204545,125.181818 C32.1116212,124.866792 30.6390851,123.124146 30.6636364,121.090909 L30.6636364,103.725 C28.7,104.543182 26.4909091,104.543182 24.5272727,103.725 L24.5272727,121.131818 C24.551824,123.165055 23.0792879,124.907701 21.0704545,125.222727 C17.3272727,125.897727 15.9568182,127.268182 15.5068182,128.638636 C15.4155957,128.951155 15.4786134,129.288435 15.6765252,129.546932 C15.8744369,129.805429 16.1835957,129.954258 16.5090909,129.947727 L38.6818182,129.947727 C39.0069615,129.956745 39.3162617,129.807418 39.5114227,129.547203 C39.7065838,129.286989 39.7633333,128.948249 39.6636364,128.638636 C39.2136364,127.247727 37.8636364,125.856818 34.1204545,125.181818 Z"
              class="fill-light"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M34.1204545,125.181818 C32.1116212,124.866792 30.6390851,123.124146 30.6636364,121.090909 L30.6636364,103.725 C28.7,104.543182 26.4909091,104.543182 24.5272727,103.725 L24.5272727,121.131818 C24.551824,123.165055 23.0792879,124.907701 21.0704545,125.222727 C17.3272727,125.897727 15.9568182,127.268182 15.5068182,128.638636 C15.4155957,128.951155 15.4786134,129.288435 15.6765252,129.546932 C15.8744369,129.805429 16.1835957,129.954258 16.5090909,129.947727 L38.6818182,129.947727 C39.0069615,129.956745 39.3162617,129.807418 39.5114227,129.547203 C39.7065838,129.286989 39.7633333,128.948249 39.6636364,128.638636 C39.2136364,127.247727 37.8636364,125.856818 34.1204545,125.181818 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M32.7090909,101.270455 C32.7090909,102.947727 30.4181818,104.338636 27.5954545,104.338636 C24.7727273,104.338636 22.4818182,102.947727 22.4818182,101.270455 L22.4818182,97.1795455 L32.7090909,97.1795455 L32.7090909,101.270455 Z"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M32.7090909,97.1795455 L22.4818182,97.1795455 L8.36818182,78.3613636 C8.13575351,78.0514592 8.09836672,77.6368334 8.27160855,77.2903497 C8.44485039,76.9438661 8.79898312,76.725 9.18636364,76.725 L46.0454545,76.725 C46.4328351,76.725 46.7869678,76.9438661 46.9602096,77.2903497 C47.1334515,77.6368334 47.0960647,78.0514592 46.8636364,78.3613636 L32.7090909,97.1795455 Z"
              class="fill-light"
              fill-rule="nonzero" />
            <polygon
              id="Path"
              class="fill-white"
              fill-rule="nonzero"
              points="11.7431818 82.8613636 22.4818182 97.1795455 32.7090909 97.1795455 43.4477273 82.8613636" />
            <path
              id="Path"
              d="M32.7090909,97.1795455 L22.4818182,97.1795455 L8.36818182,78.3613636 C8.13575351,78.0514592 8.09836672,77.6368334 8.27160855,77.2903497 C8.44485039,76.9438661 8.79898312,76.725 9.18636364,76.725 L46.0454545,76.725 C46.4328351,76.725 46.7869678,76.9438661 46.9602096,77.2903497 C47.1334515,77.6368334 47.0960647,78.0514592 46.8636364,78.3613636 L32.7090909,97.1795455 Z"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <polygon
              id="Path"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="11.7431818 82.8613636 22.4818182 97.1795455 32.7090909 97.1795455 43.4477273 82.8613636" />
            <path
              id="Path"
              d="M5.13636364,72.6340909 C5.13636364,72.6340909 -1,60.3613636 1.04545455,54.225"
              class="stroke"
              stroke-width="2.04545455"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <circle
              id="Oval"
              class="fill-white"
              fill-rule="nonzero"
              cx="7.14090909"
              cy="74.6795455"
              r="6.13636364" />
            <circle
              id="Oval"
              class="stroke fill-light"
              stroke-width="2.04545455"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              cx="7.14090909"
              cy="74.6795455"
              r="6.13636364" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
